// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const PublishLens = (): ReactElement => (
    <FormattedMessage id="apps.lens.hooks.publishLens" description="Publish lens." defaultMessage="Publish" />
);
PublishLens.displayName = "PublishLens";

export const ViewDetails = (): ReactElement => (
    <FormattedMessage id="apps.lens.hooks.viewDetails" description="View details." defaultMessage="View Details" />
);
ViewDetails.displayName = "ViewDetails";
